export const API_CONFIG = {
    USER_BASE_URL: 'https://backend-466519766426.us-central1.run.app',
    CHAT_BASE_URL: 'https://chat-agent-466519766426.us-central1.run.app',
    ENDPOINTS: {
        CREATE_USER: '/user/create',
        GET_USER: '/user',
        CONVERSATION: '/conversation-stream',
        GET_CONVERSATION: '/get-conversation'
    }
};